import React, { Component, Fragment } from "react";
import api from "../../../../../services/api";
import Dados from "../../Geral/Dados"

export default class Card extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mes: "Anual",
            modalidade: "Todas"
        }
    }

    render() {
        let { titulo, subtitulo } = this.props;
        return (
            <Fragment>

                <div className="row">
                    <div className="col-md-12">
                        <div className="card ">
                            <div className="card-header ">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h5 className="card-title">{titulo || "Geral Total"}</h5>
                                        <h6>{subtitulo || "Soluções em Tecnologia e Inovação - STI"}</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body ">
                                <div>
                                    { !this.props.children ?
                                        <Dados />
                                        :
                                        this.props.children
                                    }
                                </div>
                            </div>
                            <div className="card-footer ">
                                <hr />
                                <div className="stats">
                                    <i className="fa fa-history"></i> {new Date().toLocaleDateString("pt-br", { dateStyle: "full" })}
                                    <span style={{ float: 'right' }}>
                                        <button className="btn btn-outline-primary btn-round btn-sm" style={{ fontSize: '0.500em' }}>
                                            Visão Unidades
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}